var LEGENDS_METADATA = {
  bubble: {
    legendType: 'size'
  },
  category: {
    legendType: 'color'
  },
  choropleth: {
    legendType: 'color'
  },
  custom: {
    legendType: 'color'
  },
  custom_choropleth: {
    legendType: 'color'
  }
};

module.exports = LEGENDS_METADATA;



//////////////////
// WEBPACK FOOTER
// ./lib/assets/javascripts/builder/data/legends/legends-metadata.js
// module id = 580
// module chunks = 0 2